export default __webpack_public_path__ + "static/media/ico_email.1875c2c0.svg";